import {Box, Stack, Tooltip, Typography} from "@mui/material";
import React from "react";
import {TooltipBoxProps} from "./TooltipBox.props";
import "./TooltipBox.styles.css";

const TooltipBox: React.FC<TooltipBoxProps> = ({tooltip, children, popupStyle={}}) => {
  return (
    <Tooltip
      title={tooltip}
      placement="top"
      data-testid="tooltip-box-tooltip"
      slotProps={{
        tooltip: {
          sx: {
            ...{
              fontSize: "13px",
              width: "auto",
              maxWidth: "446px"
            },
            ...popupStyle
          }
        }
      }}
    >
      <Box
        className="tooltip-box-container"
        onMouseDown={(event: any) => event.preventDefault()}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default TooltipBox;